<template>
  <b-table
    :data="applications"
    :loading="$apollo.loading"
    :paginated="true"
    :per-page="perPage"
    :total="totalCount"
    backend-pagination
    backend-sorting
    @sort="handleSort"
    @page-change="page = $event">

    <template slot-scope="props">
      <b-table-column field="name" label="Applicant" sortable>
        {{ props.row.name }}
      </b-table-column>
      <b-table-column field="date" label="Date" sortable>
        {{ props.row.createdAt | moment("  MMMM DD, YYYY [at] h:mm a")}}
      </b-table-column>
      <b-table-column label="Review">
        <router-link :to="{ name: 'applicantDetails', params: { id: props.row.id } }">View</router-link>
      </b-table-column>
    </template>

    <template slot="empty">
      No applications found.
    </template>
  </b-table>
</template>

<script>
import { pendingApplicationsQuery, rejectedApplicationsQuery, approvedApplicationsQuery,
  pendingApplicationsCountQuery, rejectedApplicationsCountQuery, approvedApplicationsCountQuery
} from '../../graphql/applications'

// map of variables based on the stage (tab) that's being viewed
const stagesMap = {
  pending: {
    stage: 'pending',
    queryName: 'pendingApplications',
    query: pendingApplicationsQuery,
    orderBy: 'createdAt_DESC',
    countQueryName: 'pendingApplicationsCount',
    countQuery: pendingApplicationsCountQuery
  },
  approved: {
    stage: 'approved',
    queryName: 'approvedApplications',
    query: approvedApplicationsQuery,
    orderBy: 'name_ASC',
    countQueryName: 'approvedApplicationsCount',
    countQuery: approvedApplicationsCountQuery
  },
  rejected: {
    stage: 'rejected',
    queryName: 'rejectedApplications',
    query: rejectedApplicationsQuery,
    orderBy: 'name_ASC',
    countQueryName: 'rejectedApplicationsCount',
    countQuery: rejectedApplicationsCountQuery
  }
}

export default {
  name: 'Applications',
  props: {
    stage: String
  },
  data () {
    return {
      perPage: 15,
      page: null,
      orderBy: null
    }
  },
  apollo: {
    // dynamically build the query based on the stage
    applications: {
      query () {
        return stagesMap[this.stage].query
      },
      variables () {
        return {
          orderBy: this.orderBy || stagesMap[this.stage].orderBy,
          skip: this.page ? (this.page - 1) * this.perPage : 0,
          first: this.perPage
        }
      },
      update (data) {
        return data[stagesMap[this.stage].queryName]
      },
      skip () {
        return this.stage !== stagesMap[this.stage].stage
      },
      fetchPolicy: 'network-only'
    },
    totalCount: {
      query () {
        return stagesMap[this.stage].countQuery
      },
      update (data) {
        return data[stagesMap[this.stage].countQueryName]
      },
      skip () {
        return this.stage !== stagesMap[this.stage].stage
      },
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    handleSort (sort, order) {
      // convert to expected format
      this.orderBy = sort + '_' + order.toUpperCase()
    }
  }
}

</script>
